import { Box, 
    Button as MuiButton, DialogActions as MuiDialogActions,
    DialogContent as MuiDialogContent,
    DialogContentText as MuiDialogContentText,
    DialogTitle as MuiDialogTitle,
    Typography } from '@mui/material';
import { styled } from '@mui/system';

import { colors } from '../../../theme';
import { Colors } from '../../../utils/Colors';

export const BG = styled(Box)`
    background-color: ${Colors.cinder};
    min-height: 100vh;
    min-width: fit-content;
`;

export const Container = styled(Box)`
    background-color: ${Colors.cinder};
    padding: 20px;
    height: 100%;
`;

export const NextWorkButton = styled(Typography)`
    background-color: ${Colors.novajoWhite10};
    width: 138px;
    height: 40px;
    border-radius: 100px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    color: ${Colors.mainGold};
    font: 500 14px 'Inter';
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const DescriptionTermsContainer = styled(Box)`
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 15px;
    
    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

export const DescriptionWrapper = styled(Box)`
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: flex-start;
    gap: 5px;
`;

export const DescriptionBox = styled(Box)`
    background-color: ${Colors.tealishBlue};
    border-radius: 4px;
`;

export const dialogPaperProps = {
    style: {
        backgroundColor: colors.darkBlue,
        color: colors.white,
        padding: '20px',
        borderRadius: '8px',
        margin: '16px',
        maxWidth: '600px'
    }
};

export const DialogTitle = styled(MuiDialogTitle)({
    textAlign: 'center',
    fontWeight: 'bold'
});

export const DialogContent = styled(MuiDialogContent)({
    textAlign: 'center'
});

export const DialogContentText = styled(MuiDialogContentText)({
    textAlign: 'center',
    color: colors.white
});

export const DialogActions = styled(MuiDialogActions)({
    justifyContent: 'center',
    alignItems: 'center',
    color: colors.white,
    gap: '8px'
});

export const ConfirmButton = styled(MuiButton)({
    backgroundColor: colors.lightningYellow,
    color: colors.white,
    width: '80px',
    borderRadius: '40px',
    textTransform: 'none',
    '&:hover': {
        backgroundColor: colors.yellow60
    }
});

export const CancelButton = styled(MuiButton)({
    backgroundColor: 'transparent',
    color: colors.white,
    width: '80px',
    borderRadius: '40px',
    textTransform: 'none',
    border: `1px solid ${colors.white}`,
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)'
    }
});

export const QuestReviewContainer = styled(Box)({
    marginTop: '20px'
});
